import type React from 'react';

import { usePayments } from '../../../context/PaymentsProvider';

import EwalletComponent from './EwalletComponent';

const Ewallet: React.FC = () => {
  const { eWallet } = usePayments();

  if (!eWallet) {
    return <></>;
  }

  return <EwalletComponent {...eWallet} />;
};

export default Ewallet;
